import { useQuery } from "react-query";

import { searchService } from "services";

type UseMerchantSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useMerchantSearchQuery = ({
	pattern,
	page,
	options,
}: UseMerchantSearchQueryProps) =>
	useQuery(
		["merchantSearch", pattern, page],
		() =>
			searchService.getMerchants({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useMerchantSearchQuery;
